import React from 'react';
import { useTranslation, LANGUAGE_OPTIONS } from '../i18n/LanguageContext';
import './LanguageSwitcher.css';

/**
 * Language dropdown for the public application form. Placed at the top of
 * the page (inside the blue header), before any of the form content, so an
 * applicant who does not read English can switch language before they even
 * reach the first question - rather than finding it buried inside the form.
 */
function LanguageSwitcher() {
  const { language, setLanguage, t } = useTranslation();

  return (
    <div className="language-switcher">
      <select
        id="apply-language-select"
        className="language-switcher-select"
        aria-label={t('languageSwitcher.label')}
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
      >
        {LANGUAGE_OPTIONS.map(({ code, name }) => (
          <option key={code} value={code}>{name}</option>
        ))}
      </select>
    </div>
  );
}

export default LanguageSwitcher;
